// js-menu-active na body
const headerFormOpenBtn = document.querySelector('.js-header-form-open-btn');
const headerFormCloseBtn = document.querySelector('.js-header-form-close-btn');
const headerForm = document.querySelector('.js-header-form');

if (headerFormOpenBtn && headerFormCloseBtn && headerForm) {
  headerFormOpenBtn.addEventListener('click', () => {
    headerForm.classList.toggle('js-active');
    document.body.classList.toggle('js-menu-active');

    document.querySelector(".k-input--search").focus();
  });
  headerFormCloseBtn.addEventListener('click', () => {
    headerForm.classList.remove('js-active');
    document.body.classList.remove('js-menu-active');
  });
}
